import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { APP_CONFIG } from '../../../config';
import { RequestModel } from '../models/request-model';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  private planUrl = `api:8EGeW8vT${APP_CONFIG.stagingName}`;
  private userUrl = `api:oVl64uWz${APP_CONFIG.stagingName}`;
  private sdkUrl = `api:p7cV6HxK${APP_CONFIG.stagingName}`;

  constructor(private http: HttpClient, private apiService: ApiService<any>) { }

  getRequests(params?: any, skipLoader = false): Observable<RequestModel[]> {
    return this.apiService
      .getAllByParams<RequestModel>(`${this.planUrl}/contact_us_request`, {
        params,
        skipLoader,
      })
      .pipe(
        catchError((error) => {
          return throwError(
            () => new Error(error.error?.message || 'Failed to load end users.')
          );
        })
      );
  }

  getPartnerRequests(params?: any, skipLoader = false): Observable<any> {
    return this.apiService
      .getAllByParams<any>(`${this.planUrl}/get/partner_request`, {
        params,
        skipLoader,
      })
      .pipe(
        catchError((error) => {
          return throwError(
            () => new Error(error.error?.message || 'Failed to load partner requests.')
          );
        })
      );
  }

  getCashSubscriptions(params?: any, skipLoader = false): Observable<any> {
    return this.apiService
      .getAllByParams<any>(`${this.userUrl}/cash_subscriptions`, {
        params,
        skipLoader,
      })
      .pipe(
        catchError((error) => {
          return throwError(
            () => new Error(error.error?.message || 'Failed to load cash subscriptions.')
          );
        })
      );
  }

  updateCashApproval(payload: {
    user_id: number;
    isApprove: boolean;
    message: string;
  }): Observable<any> {
    return this.apiService.add<any>(`${this.userUrl}/cash-approve-admin`, payload).pipe(
      catchError((error) => {
        return throwError(
          () =>
            new Error(
              error.error?.message || 'Failed to update cash approval.'
            )
        );
      })
    );
  }

  getSdkCashRequests(params?: any, skipLoader = false): Observable<any> {
    return this.apiService
      .getAllByParams<any>(`${this.sdkUrl}/sdk_configs_list`, {
        params,
        skipLoader,
      })
      .pipe(
        catchError((error) => {
          return throwError(
            () => new Error(error.error?.message || 'Failed to load SDK cash requests.')
          );
        })
      );
  }

  updateSdkConfig(payload: any): Observable<any> {
    return this.apiService.add<any>(`${this.sdkUrl}/sdk_config_edit`, payload).pipe(
      catchError((error) => {
        return throwError(
          () => new Error(error.error?.message || 'Failed to update SDK config.')
        );
      })
    );
  }

  getPendingOnlinePayments(params?: any, skipLoader = false): Observable<any> {
    return this.apiService
      .getAllByParams<any>(`${this.sdkUrl}/online_pending_payment`, {
        params,
        skipLoader,
      })
      .pipe(
        catchError((error) => {
          return throwError(
            () => new Error(error.error?.message || 'Failed to load pending online payments.')
          );
        })
      );
  }

  updatePendingOnlinePayment(payload: { id: number; payment_status: string }): Observable<any> {
    return this.apiService
      .patch<any>(`${this.sdkUrl}/online_pending_payment`, payload.id, payload as any)
      .pipe(
        catchError((error) => {
          return throwError(
            () => new Error(error.error?.message || 'Failed to update online payment.')
          );
        })
      );
  }

  updateContactRequestStatus(payload: {
    id: number;
    status: string;
  }): Observable<any> {
    return this.apiService
      .put<any>(`${this.planUrl}/update_contact_us_request`, payload)
      .pipe(
        catchError((error) => {
          return throwError(
            () =>
              new Error(
                error.error?.message || 'Failed to update request status.'
              )
          );
        })
      );
  }



}
